import React from 'react';
import { reducer as formReducer } from 'redux-form';
import { reducer as uiReducer } from 'redux-ui';

import PageWithToolbar from 'components/Common/PageWithToolbar';

import IndividualBootstrap from '../Common/Data/IndividualBootstrap';
import { createReduxStore } from '../Common/Data/StoreCreator';

import ToolbarPropTypes from './v2/ToolbarPropTypes';

const ToolbarBootstrap = ({ theProps, ...rest }) => {
  const store = createReduxStore({
    ui: uiReducer,
    form: formReducer,
  });

  return (
    <div>
      <IndividualBootstrap store={store}>
        <PageWithToolbar toolbarProps={theProps} legacyToolbar {...rest} />
      </IndividualBootstrap>
    </div>
  );
};

ToolbarBootstrap.propTypes = {
  theProps: ToolbarPropTypes,
};

export default ToolbarBootstrap;
